import script from "./403.vue?vue&type=script&setup=true&lang=js"
export * from "./403.vue?vue&type=script&setup=true&lang=js"

import "./403.vue?vue&type=style&index=0&id=675b3e7b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-675b3e7b"]])

export default __exports__